/**
 * @file App's entry point.
 */
import 'core-js/stable'

import Configurator from 'core-js/configurator'

// Used by Google Pay button, not supported on Edge
import 'get-root-node-polyfill/implement'
import 'regenerator-runtime/runtime'

import { useLayoutEffect } from 'react'
import { createRoot } from 'react-dom/client'
import Ravelin from 'ravelinjs/core'

import { App } from './App'
import config from './env'

import { Storage as storage } from 'utils'

import './utils/logging/datadog'
import './utils/logging/sentry'

const GA_ID = 'G-V9CKMRJHL3'

const Main = () => {
  useLayoutEffect(() => {
    new Ravelin({
      key: config.ravelinKey,
      cookieDomain: config.ravelinCookieDomain,
    })

    // Save GA session in local storage
    const sessionIdPromise = new Promise((resolve) => {
      gtag('get', `${GA_ID}`, 'session_id', resolve)
    })
    const sessionNumPromise = new Promise((resolve) => {
      gtag('get', `${GA_ID}`, 'session_number', resolve)
    })

    Promise.all([sessionIdPromise, sessionNumPromise]).then((session_data) => {
      storage.set('gaSession', {
        gaSessionId: session_data[0],
        gaSessionNumber: session_data[1],
      })
    })

    // active Segment using the marshmallow.co domain as a proxy
    window.analytics.load(config.segmentkey, {
      integrations: { 'Segment.io': { apiHost: 'analytics.marshmallow.co/v1' } },
    })

    // https://github.com/zloirock/core-js#configurable-level-of-aggressiveness
    Configurator({
      usePolyfill: ['Promise'],
    })
  }, [])

  return <App />
}

const container = document.getElementById('root')
const root = createRoot(container!) // createRoot(container!) if you use TypeScript
root.render(<Main />)
